import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
} from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  clearTravelForm,
  setLanguage,
  updateTravelForm,
} from '../../redux/modules/travelClaim';
import { clearFileUrls } from '../../helpers/uploadHelpers';
import CompensationContainer from '../CompensationContainer';
import { CLAIM_TYPES } from '../../constants';
import { clearApplicantSearch } from '../../redux/modules/searchApplicant';
import claimSteps from './claimSteps';
import { getCountries, getStates } from '../../redux/modules/countries';
import { updateClaimForm } from '../../helpers/claims/claimApplicationHelpers';
import ScrollToTopPage from '../../components/ScrollToTopPage';
import { bindClaimConclusionSuccessTableData } from '../../helpers/claims';

import ClaimHeartIcon from '../../img/claims/heart.png';

const TravelCompensationContainer = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = useRef(i18n.language);
  const travelClaim = useSelector((store) => store.travelClaim, shallowEqual);
  const countries = useSelector((store) => store.countriesReducer.countries);

  const {
    searchData: { applicant, policies },
  } = useSelector((store) => store.searchApplicant, shallowEqual);

  useLayoutEffect(() => {
    dispatch(setLanguage(currentLanguage.current));
  }, [dispatch]);

  useEffect(
    () => () => {
      dispatch(clearTravelForm());
      dispatch(clearApplicantSearch());
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch(getCountries());
    dispatch(getStates());
  }, [dispatch]);

  useEffect(() => {
    if (travelClaim.submitSuccess && travelClaim.attachments) {
      clearFileUrls(travelClaim.attachments.files);
    }
  }, [travelClaim]);

  useEffect(() => {
    updateClaimForm(dispatch, updateTravelForm, applicant, policies, countries);
  }, [applicant, countries, dispatch, policies]);

  const claimSuccessData = useMemo(
    () => {
      if (travelClaim.submitSuccess) {
        return bindClaimConclusionSuccessTableData(travelClaim, t, i18n.language);
      }
      return undefined;
    },
    [travelClaim, t, i18n.language],
  );

  return (
    <>
      <ScrollToTopPage />
      <CompensationContainer
        claimSteps={claimSteps}
        claim={travelClaim}
        headerText="claim.travelClaimHeaderText"
        headerImage={ClaimHeartIcon}
        type={CLAIM_TYPES.TRAVEL}
        clearForm={clearTravelForm}
        clearApplicantSearch={clearApplicantSearch}
        formLanguage={travelClaim.language}
        claimSuccessData={claimSuccessData}
      />
    </>
  );
};

export default TravelCompensationContainer;
